export const CONTACT = {
  phoneDisplay: "+91 96005 36354",
  phoneHref: "tel:+919600536354",
  email: "info@expante.com",
  emailHref: "mailto:info@expante.com",
  addressLines: ["Lionforce Technologies Pvt Ltd", "Chennai, India", "Serving clients globally"],
};

export const LOGOS = {
  expante: "/assets/expante-logo.png",
  lionforce: "/assets/lion-icon.png",
};

export const NAV_LINKS = [
  { label: "Proposition", href: "#partner" },
  { label: "Models", href: "#models" },
  { label: "Sectors", href: "#sectors" },
  { label: "Pricing", href: "#pricing" },
  { label: "Compare", href: "#compare" },
  { label: "Process", href: "#process" },
  { label: "Blog", href: "/blog" },
];
